export const API_URL =
  process.env.REACT_APP_ENV === 'prod'
    ? 'https://apnigaadi-api.apisod.ai/'
    : process.env.REACT_APP_ENV === 'test'
      ? 'https://apnigaadi-api.apisod.ai/'
      : 'https://apnigaadi-api.apisod.ai/';
